import { Component } from '@angular/core';
import { AdminHotelNavbarComponent } from '../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { AdminHotelSlideComponent } from '../../components/admin-hotel-slide/admin-hotel-slide.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NavbarComponent } from "../../components/navbar/navbar.component";

@Component({
  selector: 'app-admin-hotel',
  imports: [
    AdminHotelNavbarComponent,
    AdminHotelSlideComponent,
    FooterComponent,
    NavbarComponent
],
  templateUrl: './admin-hotel.component.html',
  styleUrls: ['./admin-hotel.component.css']
})
export class AdminHotelComponent {

}
